/** @jsxImportSource @emotion/react */
import { Tag } from "primereact/tag";
import { Boton } from "../../../../shared";
import Flujograma from "../../../../elementos/Flujograma";

// Flujograma de la configuración de un tipo de actividad: cada paso es una
// caja con sus datos y un menú para editarlo. La ubicación de las cajas y las
// flechas las resuelve Flujograma.

const ANCHO_PASO = 230;
const ALTO_PASO = 112;

const unaLinea = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
};

/**
 * @param {{id: number, nombre: string, tipo: string, decisor: string, aceptaAdministrador: boolean}[]} pasos en orden
 * @param {object[]} transiciones ver Flujograma
 * @param {number|null} pasoInicialId paso en el que empieza la actividad
 * @param {(paso, evento) => void} onMenu se llama al tocar el menú de un paso
 */
export default function DiagramaFlujo({
  pasos,
  transiciones,
  pasoInicialId,
  onMenu
}) {
  return (
    <Flujograma
      pasos={pasos}
      transiciones={transiciones}
      pasoInicialId={pasoInicialId}
      anchoPaso={ANCHO_PASO}
      altoDePaso={() => ALTO_PASO}
      estiloDePaso={(paso) => ({
        padding: "8px 6px 8px 12px",
        borderColor:
          paso.id === pasoInicialId ? "var(--principal)" : "var(--grisTextos)",
        "& .p-button": { width: "1.6rem", height: "1.6rem", padding: 0 }
      })}
      renderPaso={(paso) => (
        <>
          <div
            css={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "4px"
            }}
          >
            <strong css={{ fontSize: "0.9rem", ...unaLinea }}>
              {paso.nombre}
            </strong>
            <Boton icono negro callback={(e) => onMenu(paso, e)}>
              <i className="pi pi-ellipsis-v" />
            </Boton>
          </div>
          <div css={unaLinea}>{paso.tipo}</div>
          <div css={{ color: "var(--grisTextos)", ...unaLinea }}>
            Decisor: {paso.decisor}
          </div>
          <div css={{ color: "var(--grisTextos)", ...unaLinea }}>
            {paso.aceptaAdministrador
              ? "Acepta administradores"
              : "No acepta administradores"}
          </div>
          {paso.id === pasoInicialId && (
            <Tag
              value="Inicio"
              css={{
                position: "absolute",
                top: "-0.7rem",
                left: "10px",
                fontSize: "0.65rem",
                padding: "1px 8px"
              }}
            />
          )}
        </>
      )}
    />
  );
}
